"use server";

// The website's contact form: open to anyone, so it reads nothing and answers nothing about hotels.
import { headers } from "next/headers";
import { z } from "zod";
import { run } from "@/core/actions";
import { recordEnquiry } from "./enquiry";

const schema = z.object({
  name: z.string().trim().min(2, "Please enter your name").max(100),
  hotel: z.string().trim().min(2, "Please enter your hotel's name").max(120),
  mobile: z.string().trim().refine((v) => v.replace(/\D/g, "").length >= 10 && v.replace(/\D/g, "").length <= 15, "Please enter a mobile number we can call"),
  email: z.string().trim().email("Please check your email address").optional().or(z.literal("")),
  city: z.string().trim().max(80).optional(),
  rooms: z.string().trim().max(20).optional(),
  message: z.string().trim().max(1000).optional(),
  website: z.string().max(200).optional(),
  elapsedMs: z.number().optional(),
});

export async function sendEnquiryAction(input: z.input<typeof schema>) {
  return run(async () => {
    const d = schema.parse(input);
    // A filled hidden field, or a form sent the instant it opened, is not a person. They are told
    // it worked, because telling them it did not only teaches them what to change.
    if (d.website || (d.elapsedMs !== undefined && d.elapsedMs < 1500)) return { received: true };
    const referer = (await headers()).get("referer");
    await recordEnquiry({ name: d.name, hotel: d.hotel, mobile: d.mobile, email: d.email, city: d.city, rooms: d.rooms, message: d.message, page: referer?.slice(0, 300) });
    return { received: true };
  });
}
